import { hot } from 'react-hot-loader'
import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import MomentUtils from '@date-io/moment'
import * as Sentry from '@sentry/browser'

import { ToastContainer } from 'material-react-toastify'
import { ToastContainer as ToastContainerReact } from 'react-toastify'

// eslint-disable-next-line
import '!style-loader!css-loader!material-react-toastify/dist/ReactToastify.min.css'
// react-dates initialization
import 'react-dates/initialize'
// eslint-disable-next-line
import '!style-loader!css-loader!react-dates/lib/css/_datepicker.css'
// eslint-disable-next-line
import '!style-loader!css-loader!react-datepicker/dist/react-datepicker.css'
// eslint-disable-next-line
import '!style-loader!css-loader!rc-color-picker/assets/index.css'
// eslint-disable-next-line
import '!style-loader!css-loader!rc-slider/assets/index.css'
// eslint-disable-next-line
import '!style-loader!css-loader!slick-carousel/slick/slick.css'
// eslint-disable-next-line
import '!style-loader!css-loader!slick-carousel/slick/slick-theme.css'
// eslint-disable-next-line
import 'react-toastify/dist/ReactToastify.min.css'

import AuthenticatedApp from './authenticated-app'
import ErrorBoundary from '../../common-components/error-boundary'


Sentry.init({ dsn: 'https://d4477484e6264306bf754a7376706f9b@sentry.io/2219477' })

const App = () => {

  return (
    <ErrorBoundary key='App'>
      <div>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <ToastContainer
            position='top-center'
            autoClose={3000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
          <ToastContainerReact
            position='top-center'
            type='default'
            autoClose={3000}
            hideProgressBar
            newestOnTop={false}
            rtl={false}
            pauseOnFocusLoss
            draggable
            closeOnClick
            pauseOnHover
          />
          <Router>
            <AuthenticatedApp />
          </Router>
        </MuiPickersUtilsProvider>
      </div>
    </ErrorBoundary>
  )
}

export default hot(module)(App)
